// src/components/Snackbar/Snackbar.tsx
import React, {FC, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import styles from './styles.module.scss';
import LazyAssets from "@/app/utils/assets_widget";
import {ButtonText} from "@/app/components/texts";
import classNames from "classnames";

interface SnackbarProps {
  message: string | null;
  duration: number;
  onClose: () => void;
  isError: boolean
}

const Snackbar: FC<SnackbarProps> = ({message, duration, onClose, isError}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return;
    setVisible(true);
    const timer = setTimeout(() => {
      onClose();
      setVisible(false);
    }, duration);
    return () => clearTimeout(timer);
  }, [message, duration]);

  if (!visible || !message) return null;

  return ReactDOM.createPortal(
    <div className={classNames(styles.snackbar, {[styles.error]: isError})}>
      {/*<button className={styles.Close} onClick={() => setVisible(false)}>*/}
      {/*  &times;*/}
      {/*</button>*/}
      {isError ? <LazyAssets.Close className={styles.close} onClick={onClose}/> :
        <LazyAssets.Select className={styles.close} onClick={onClose}/>}
      <ButtonText text={message} className={styles.message}/>
    </div>,
    document.body
  );
};

export default Snackbar;